import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { styled as muiStyled } from "@mui/material/styles";
import styled from "styled-components";
import ConnorsTheme from "../../paid_landing_page/connorsTheme";

const CONNORS_BLACK = ConnorsTheme.black;
const CONNORS_WHITE = "#ffffff";

export const DialogStyled = muiStyled(Dialog)({
  "& .MuiDialog-paper": {
    backgroundColor: CONNORS_BLACK,
    backgroundImage:
      'url("https://assets.wobbjobs.com/images/connors-popup-bg.png")',
    backgroundSize: "cover",
    backgroundPosition: "bottom",
    backgroundRepeat: "no-repeat",
    borderRadius: "16px",
    maxWidth: "820px",
    width: "calc(100% - 2rem)",
    margin: "1rem",
    overflow: "hidden",
    fontFamily:
      '"Hops and Barley C4", "Helvetica Neue", Helvetica, Arial, sans-serif',

    "@media (max-width: 639px)": {
      width: "calc(100% - 1rem)",
      margin: "0.5rem",
      borderRadius: "12px",
    },
  },
});

export const DialogContent = styled(Grid)`
  && {
    position: relative;
    width: 100%;
    min-height: 500px;
    padding: 3rem 1.5rem 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 1.25rem;
    justify-content: flex-start;

    @media (max-width: 639px) {
      min-height: 380px;
      padding: 2rem 1rem 1.25rem;
      gap: 0.75rem;
    }
  }
`;

export const CloseButton = muiStyled(IconButton)({
  position: "absolute",
  top: "0.75rem",
  right: "0.75rem",
  color: CONNORS_WHITE,
  zIndex: 1,

  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.08)",
  },

  "@media (max-width: 639px)": {
    top: "0.5rem",
    right: "0.5rem",
    padding: "0.35rem",
  },
});

export const CloseIconStyled = muiStyled(CloseIcon)({
  fontSize: "1.5rem",

  "@media (max-width: 639px)": {
    fontSize: "1.25rem",
  },
});

export const LogoImage = styled.img`
  width: 220px;
  height: auto;
  object-fit: contain;

  @media (max-width: 639px) {
    width: 130px;
  }
`;

export const CollectiveTitle = styled(Typography)`
  && {
    font-size: 50px;
    font-weight: 400;
    letter-spacing: 0.08rem;
    line-height: 1;
    color: ${CONNORS_WHITE};
    text-transform: uppercase;
    font-family: "Hops and Barley C4", "Helvetica Neue", Helvetica, Arial,
      sans-serif;
    margin-top: -0.95rem;
    margin-bottom: 20px;

    @media (max-width: 639px) {
      font-size: 30px;
      margin-top: -0.5rem;
      margin-bottom: 12px;
    }
  }
`;

export const ConfirmationText = styled(Typography)`
  && {
    font-size: 25px;
    font-weight: 400;
    letter-spacing: 0.04rem;
    line-height: 1.15;
    color: ${CONNORS_WHITE};
    text-transform: uppercase;
    max-width: 700px;
    font-family: "Hops and Barley C4", "Helvetica Neue", Helvetica, Arial,
      sans-serif;

    @media (max-width: 639px) {
      font-size: 15px;
      line-height: 1.15;
      max-width: 300px;
    }
  }
`;

export const ButtonRow = styled(Grid)`
  && {
    display: flex;
    gap: 1rem;
    width: 100%;
    max-width: 350px;
    justify-content: center;
    margin-top: 0.4rem;

    @media (max-width: 639px) {
      gap: 0.65rem;
      max-width: 280px;
      margin-top: 0.25rem;
    }

    @media (max-width: 480px) {
      flex-direction: row;
      max-width: 240px;
    }
  }
`;

export const ConfirmButton = styled.button`
  flex: 1;
  min-width: 0;
  min-height: 35px;
  padding: 0.6rem 0.8rem 0.3rem;
  background: #ec0036;
  border: 1px solid #ec0036;
  border-radius: 6px;
  color: ${CONNORS_WHITE};
  font-size: 18px;
  line-height: 1;
  font-weight: 400;
  text-transform: uppercase;
  font-family: "Hops and Barley C4", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  cursor: pointer;
  transition: filter 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  &:hover {
    filter: brightness(1.1);
  }

  @media (max-width: 639px) {
    min-height: 32px;
    padding: 0.45rem 0.6rem 0.25rem;
    font-size: 14px;
    border-radius: 5px;
  }

  @media (max-width: 480px) {
    width: 50%;
    min-height: 32px;
    font-size: 14px;
  }
`;

export const CheckboxRow = styled(Grid)`
  && {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 0.15rem;

    @media (max-width: 639px) {
      margin-top: 0.05rem;
    }
  }
`;

export const DisclaimerText = styled(Typography)`
  && {
    width: 100%;
    max-width: 760px;
    margin: 0 auto;
    padding-top: 1.1rem;
    font-size: 0.7rem;
    line-height: 1.18;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.92);
    text-align: center;
    text-transform: uppercase;
    font-family: "Hops and Barley C4", "Helvetica Neue", Helvetica, Arial,
      sans-serif;

    @media (max-width: 639px) {
      font-size: 0.5rem;
      line-height: 1.15;
      padding-top: 0.75rem;
      max-width: 300px;
    }
  }
`;
